import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";

export default {
    namespaced: true,
    state: {
        bulks: {},
    },
    mutations: {
        setBulks(state, bulks) {
            state.bulks = bulks
        },
        deleteBulk: (state, bulks) => {
            state.bulks.splice(findObjectIndex(store.getters['Bulk/getBulks'], bulks), 1)
        },
    },
    actions: {
        getBulks({commit}, form) {
            axios.get(`bulk/product/${form.product_id}`)
                .then(res => {
                    const data = res.data.data;
                    commit('setBulks', data)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        createBulks({commit}, form) {
            axios.post('/bulk', form)
                .then(res => {
                    toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد.')
                    const getBulkForm = {
                        product_id: form.product_id
                    }
                    store.dispatch('Bulk/getBulks', getBulkForm)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        updateBulk({commit}, form) {
            axios.put(`/bulk/${form.id}`, form)
                .then(res => {
                    toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد.')
                })
                .catch(error => {
                    console.log(error)
                })
        },
        deleteBulk({commit}, bulk) {
            axios.delete(`bulk/${bulk.id}`)
                .then(res => {
                    commit('deleteBulk', bulk)
                })
                .catch(error => {
                    console.log(error)
                })
        },
    },
    getters: {
        getBulks: state => state.bulks,
    }
}